module.exports = __webpack_public_path__ + "img/ausol4-2.a5f4a663.png";